import { Route, Routes } from 'react-router-dom';
import { SystemsShell } from '@/systems-shell/SystemsShell';
import { OldShellPlaceholder } from '@/old-shell/OldShellPlaceholder';
import { AuthCallback } from '@/systems-shell/AuthCallback';
import { FlagGate } from '@/lib/FlagGate';

export default function App() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <FlagGate whenOn={<SystemsShell />} whenOff={<OldShellPlaceholder />} />
        }
      />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function NotFound() {
  return (
    <div className="flex h-full items-center justify-center">
      <div className="glass px-8 py-6 text-ink-600">404 — page not found</div>
    </div>
  );
}
